import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PostHog and cross-origin iframe errors (doesn't affect functionality)
// These errors come from PostHog session replay trying to access Stripe iframes
const originalError = console.error;
console.error = (...args) => {
  const errorString = args.join(' ');
  if (errorString.includes('posthog') || 
      errorString.includes('cross-origin') ||
      errorString.includes('removeEventListener') ||
      errorString.includes('Blocked a frame')) {
    return; // Suppress these specific errors
  }
  originalError.apply(console, args);
};

window.addEventListener('error', (event) => {
  if (event.message && (
      event.message.includes('posthog') || 
      event.message.includes('cross-origin') ||
      event.message.includes('removeEventListener') ||
      event.message.includes('Blocked a frame')
    ) || (event.filename && event.filename.includes('posthog'))) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && (
      event.reason.toString().includes('posthog') ||
      event.reason.toString().includes('cross-origin')
    )) {
    event.preventDefault();
    return true;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
